import { EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
/**
 * Angular imports.
 */
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as HomeAction from '../../../../../featureModules/dashboard/featureModules/home/store/actions/home.actions';
import * as HomeSelector from '../../../../../featureModules/dashboard/featureModules/home/store/selectors/home.selectors';
import { Subscription } from 'rxjs';
/**
 * constants imports
 */
import {
  COUNTRIES_LIST, TH_SPR_PROCESS, AE_REPORT_STATUS, TH_SERVIER_PROCESS,
  OAZIS_FLOW_PROCESS, SG_BMS_NR_PND_1,
  NOVARTIS_PROCESS, TH_SERVIER_PRIVATE_PROCESS, TH_SERVIER_PUBLIC_PROCESS, MY_NOVO_FLOW, TH_DAICHII_PROCESS
} from 'projects/nga-PAP/src/app/constant/app.constant';
import { PharmaNameService } from 'projects/nga-PAP/src/app/services/pharma/pharma-name.service';
import aeReportValidation from '../../../.../../../../../assets/static/ae-report-validation.json';
import { notValueValidator } from 'projects/ngp-docquity-ds/src/lib/validators/notValueValidator/notValue.validator';

/**
 * Used to show the form for pediatric report.
 */
@Component({
  selector: 'pap-patient-details-form',
  templateUrl: './patient-details-form.component.html',
  styleUrls: ['./patient-details-form.component.scss']
})
export class PatientDetailsFormComponent implements OnInit, OnDestroy, OnChanges {
  @Input() functionality = '';
  @Input() formData = null;
  @Input() disableField: any;
  @Input() process: string;

  @Input() aeCurrentStatus = '';

  @Output() patientProgramDetails = new EventEmitter<any>();

  @Output() selectedProgramDetails = new EventEmitter<any>();
  /**
   * Form pediatric report.
   */
  public patientForm: FormGroup;

  public aeReportStatus  = AE_REPORT_STATUS;

  /**
   * setter for the form controls.
   */
  get form(): { [key: string]: AbstractControl } { return this.patientForm.controls; }
  get formValidity(): boolean { return (this.patientForm.valid && this.patientDetailsErrorMessages === ''); }
  get formValues(): { patientForm: any; } { return { patientForm: this.patientForm.getRawValue() }; }

  public countryList = [
    { id: 1, name: 'Thailand' }
  ];
  public heightUnit = [
    { name: 'cm', value: 'cm' },
    { name: 'm', value: 'm' },
    { name: 'ft', value: 'ft' },
    { name: 'inch', value: 'inch' }
  ];
  public weightUnit = [
    { name: 'kg', value: 'kg' },
    { name: 'g', value: 'g' },
    { name: 'pound', value: 'pound' }
  ];
  public patientIdErr: boolean;
  /**
   * last patient id value, used to detect an actual change on keyup.
   */
  private lastPatientId = '';
  public disabled: boolean;

  public filterRegisteredProgramList = [];
  public registeredProgramList = [];
  public selectedPharmaProgram = { id: '', name: '', code: '' };

  public filteredGenderList: any;
  public genderList = [
    { name: 'Male', value: 'MALE' },
    { name: 'Female', value: 'FEMALE' },
    { name: 'Prefer not to answer', value: 'OTHER' }
  ];
  public selectedGender = { name: '', value: '' };

  private subscriptions: Subscription = new Subscription();
  private pharmaNameChangeSub: Subscription;


  /**
   * patient detail error messages
   */
  public patientDetailsErrorMessages: string;
  /**
   * current date
   */
  public currentDate = new Date();
  /**
   * Necessary instances.
   */
  constructor(private fb: FormBuilder, private store: Store, private pharmaNameChange: PharmaNameService) {
    this.store.dispatch(HomeAction.resetSearchedPatientDetail());

  }
  heightUnitList = [
    { id: 1, name: 'cm' },
    { id: 2, name: 'm' },
    { id: 3, name: 'ft' },
    { id: 4, name: 'inch' }
  ];
  weightUnitList = [
    { id: 1, name: 'kg' },
    { id: 2, name: 'g' },
    { id: 3, name: 'pound' }
  ];
  patientTypeList = [
    { id: 1, name: 'IPD' },
    { id: 2, name: 'OPD' },
  ]


  /**
   * Calling initialize form.
   */
  ngOnInit(): void {
    this.patientDetailsErrorMessages = '';
    this.fetchPharmaRegisteredProgram();
    this.subscriptions.add(this.store.select(HomeSelector.getPatientDetail)
      .subscribe(patientDetail => {
        if (patientDetail) {
          this.patientIdErr = false;
          if (patientDetail && patientDetail?.length === 0) {
            this.patientIdErr = true;
            this.setPatientIdError('patientIdNotValid');
            return;
          }
          if (patientDetail.programName) {
            this.form.registeredProgramName.setValue(patientDetail.programName);
          }
          if (patientDetail.dob !== null || patientDetail.dob !== undefined) {
            this.form.dateOfBirth.setValue(new Date(patientDetail.dob * 1000));
          }
          if (patientDetail.gender) {
            this.form.patientGender.setValue(patientDetail.gender);
          }
          if (patientDetail.programShortCode) {
            this.form.registeredProgramCode.setValue(patientDetail.programShortCode);
          }
          if (patientDetail.patientInitials) {
            this.form.patientInitials.setValue(patientDetail.patientInitials);
          }
          if (patientDetail.age !== null || patientDetail.age !== undefined) {
            this.form.patientAge.setValue(patientDetail.age);
          }
          if (patientDetail.previousId) {
            this.form.previousId.setValue(patientDetail.previousId);
          } else {
            this.form.previousId.setValue('NA');
          }
          if (patientDetail.programId) {
            this.form.programId.setValue(patientDetail.programId);
          }
          this.patientProgramDetails.emit(patientDetail);
          this.setSelectedCountry();
          this.setSelectedValue();
        }
      })
    );
    /**
     * handle error on search patient
     */
    this.subscriptions.add(this.store.select(HomeSelector.getHommeError).subscribe(res => {
      if (res) {
        this.patientDetailsErrorMessages = res?.error?.messages?.toString();
        this.setPatientIdError('patientNotFound');
      }
    }));

    /**
     * handle the pharma name change to call program api
     */
    this.pharmaNameChangeSub = this.pharmaNameChange.data$.subscribe(res => {
      if (res != null){
        this.fetchPharmaRegisteredProgram();
        this.selectedPharmaProgram = { name: '', id: '', code: '' };
      }
    });
    this.disabled = this.functionality === 'view';
    if (this.checkForSingaporeCountry()){
      this.countryList = [{ id: 2, name: 'Singapore' }];
    }
    this.initializeForm();
  }
  /**
   * set selected value
   */
  setSelectedValue(): void {
    if (this.formData?.patientGender || this.patientForm.get('patientGender').value) {
      this.filteredGenderList = this.genderList;
      const gender = this.patientForm.get('patientGender').value;
      const filterOption = this.genderList.find(option => option.value === gender);
      this.selectedGender = filterOption;
    }
    if (this.patientForm.get('registeredProgramName').value) {
      const pharmaProgram = this.patientForm.get('registeredProgramName').value;
      const filterOption = this.filterRegisteredProgramList.find(option => option.name === pharmaProgram);
      this.selectedPharmaProgram = filterOption;
    }
    if (this.disableField?.patientId !== 0) {
      this.patientForm.get('patientId')?.setValue(this.disableField?.patientId);
    }
    this.lastPatientId = this.getPatientIdKey(this.patientForm.get('patientId')?.value);
  }

  /**
   * to detect changes on incoming form values
   * @param changes changes on formData
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.formData || changes?.disableField) {
      this.initializeForm();
      this.setSelectedValue();
    }
    /**
     * when change in process
     */
    if (changes?.process) {
      this.updateFormValidation();
    }
  }

  /**
   * update the form validation wrt
   * change in process
   */
  private updateFormValidation(): void {
    if (this.patientForm && this.process) {
      if (this.checkForServierProcess())
        {
          this.patientForm.removeControl('ethnicOrigin');
        }
      if (this.checkForSingaporeCountry() || this.checkForOazisProcess())
        {
          this.patientForm.get('ethnicOrigin').clearValidators();
          this.patientForm.get('ethnicOrigin').updateValueAndValidity();
          this.patientForm.get('reportType').clearValidators();
          this.patientForm.get('reportType').updateValueAndValidity();
        }
    }
  }

  /**
   * calculate age based on date of birth
   * @param event input age
   */
  calculateAge(event: any): void {
    if (event) {
      const birthDate = new Date(event);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      // If birth date is greater than today's date then decrement age by 1
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      this.patientForm.get('patientAge').setValue(age);
    }
    else {
      this.patientForm.get('patientAge').setValue(null);
    }
  }

  /**
   * Initializes the patient form with default values and validators.
   */
  initializeForm(): void {
    const formData = this.formData || {};

    // Determine if the form should be disabled based on various conditions
    const isFormDisabledForNewPatient = this.disabled
                                  || this.disableField.createPatient
                                  || this.disableField.existingUser;
    const isFormDisabledForExistingPatient = this.disabled
                                  || this.disableField.existingUser || !this.checkForProcess();
    const isPatientIdRequired = !(this.disableField.createPatient
                                  || this.disableField.existingUser);
    this.selectedPharmaProgram = { id: '', name: '', code: '' };

    // Initialize the patient form group
    this.patientForm = this.fb.group({
      patientId: new FormControl(
        { value: formData?.patientId || 0, disabled: isFormDisabledForNewPatient },
        isPatientIdRequired &&
        (this.checkIfFieldExists('patientId') && this.checkIfFieldIsMandatory('patientId'))
        ? [Validators.required, notValueValidator(0)] : []),
      registeredProgramName: new FormControl(
        { value: formData?.registeredProgramName || '', disabled: isFormDisabledForExistingPatient },
        this.checkIfFieldExists('registeredProgram') && this.checkIfFieldIsMandatory('registeredProgram')
        ? Validators.required : null),
      patientInitials: new FormControl(
        { value: formData?.patientInitials || '', disabled: this.disabled || !this.checkForProcess() },
        (this.checkIfFieldExists('patientInitials') && this.checkIfFieldIsMandatory('patientInitials'))
        ? [Validators.required, Validators.maxLength(20)] : []),
      previousId: new FormControl({ value: formData?.previousId || '', disabled: this.disabled }),
      dateOfBirth: new FormControl(
        { value: formData?.dateOfBirth ? new Date(formData.dateOfBirth) : '', disabled: this.disabled }),
      patientGender: new FormControl(
        { value: formData?.patientGender || 'NA', disabled: this.disabled || !this.checkForProcess() },
        !this.checkForProcess()
        && (this.checkIfFieldExists('patientGender') && this.checkIfFieldIsMandatory('patientGender'))
        ? [Validators.required] : null),
      patientAge: new FormControl(
        { value: formData?.patientAge !== null || formData.patientAge !== undefined ? formData.patientAge : '',
          disabled: isFormDisabledForExistingPatient },
        !this.checkForProcess()
        && (this.checkIfFieldExists('patientAge') && this.checkIfFieldIsMandatory('patientAge'))
        ? [Validators.required] : null),
      registeredProgramCode: new FormControl(formData?.registeredProgramCode || ''),
      programId: new FormControl(formData?.programId || ''),
      country: new FormControl(
        { value: formData?.country || this.countryList?.[0]?.name, disabled: this.disabled },
        (this.checkIfFieldExists('country') && this.checkIfFieldIsMandatory('country'))
        ? Validators.required : null),
      height: new FormControl(
        { value: formData?.height || '', disabled: this.disabled },
        [Validators.pattern(/^\d+(\.\d{1,2})?$/)]),

      heightUnit: new FormControl(
      { value: formData?.heightUnit || 'cm', disabled: this.disabled },
      ),

      weightUnit: new FormControl(
        { value: formData?.weightUnit || 'kg', disabled: this.disabled },
        ),

      weight: new FormControl(
        { value: formData?.weight || '', disabled: this.disabled },
        [Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
      ethnicOrigin: new FormControl(
        { value: formData?.ethnicOrigin || '', disabled: this.disabled },
        !this.checkForProcess() && 
        !this.checkForDaichiiProcess()
        && (this.checkIfFieldExists('ethnicOrigin') && this.checkIfFieldIsMandatory('ethnicOrigin'))
        ? [Validators.maxLength(20), Validators.required] : [Validators.maxLength(20)]),
      reportType: new FormControl(
        { value: formData?.reportType || '', disabled: this.disabled },
        !this.checkForProcess()
        && (this.checkIfFieldExists('reportType') && this.checkIfFieldIsMandatory('reportType'))
        ? [Validators.required] : null),
      patientType: new FormControl(
        { value: formData?.patientType || '', disabled: this.disabled },
        this.checkForDaichiiProcess()
        && (this.checkIfFieldExists('patientType') && this.checkIfFieldIsMandatory('patientType'))
        ? [Validators.required] : null),
    });
    this.lastPatientId = this.getPatientIdKey(this.patientForm.get('patientId')?.value);
    this.updateFormValidation();
  }

  /**
   * Mark the patient id control invalid when the patient search fails.
   * The error is cleared automatically on the next value change.
   * @param errorKey validation error key to set on the control
   */
  setPatientIdError(errorKey: string): void {
    const patientIdControl = this.patientForm?.get('patientId');
    if (!patientIdControl?.value) { return; }
    patientIdControl.setErrors({ ...patientIdControl.errors, [errorKey]: true });
    patientIdControl.markAsTouched();
  }

  /**
   * Normalize the patient id value so number and string values compare equal.
   */
  private getPatientIdKey(value: any): string {
    return value === null || value === undefined ? '' : String(value);
  }

  /**
   * Clear the details filled from the previously searched patient.
   */
  private clearPatientDetails(): void {
    this.patientIdErr = false;
    this.selectedGender = { name: '', value: '' };
    this.selectedPharmaProgram = { name: '', id: '', code: '' };
    this.patientForm.patchValue({
      registeredProgramName: '',
      registeredProgramCode: '',
      programId: '',
      patientInitials: '',
      dateOfBirth: '',
      patientGender: 'NA',
      patientAge: '',
      previousId: ''
    });
    this.store.dispatch(HomeAction.resetSearchedPatientDetail());
  }

  /**
   * Search the patient on user key up
   */
  searchPatient(key: string): void {
    const patientIdKey = this.getPatientIdKey(key);
    // keyup also fires for keys that don't change the value (arrows, tab, etc.)
    if (patientIdKey === this.lastPatientId) { return; }
    this.lastPatientId = patientIdKey;
    this.patientDetailsErrorMessages = '';
    this.clearPatientDetails();
    if (key) {
      this.store.dispatch(HomeAction.getSearchedPatientId({
        id: key,
        pharmaCode: localStorage.getItem('pharmaCode') ? localStorage.getItem('pharmaCode') : ''
      }));
    }
  }

  /**
   * Function to handle user input and restrict only leading/trailing blank spaces.
   * @param fieldName The name of the form field to update.
   * @param valueSource The source of the value ('id' or 'name').
   * @param event The input event object.
   */
  userInput(fieldName: string, valueSource: string, event: any): void {
    let value: string;
    if (valueSource === 'id') {
      value = event.id;
      this.patientForm.get('programId')?.setValue(value);
      this.patientForm.get('registeredProgramCode')?.setValue(event.code);
      value = event.name.trimStart();
    } else if (valueSource === 'name') {
      value = event.value.trimStart();
    }
    this.patientForm.get(fieldName).setValue(value);
  }

  /**
   * function to restrict only blankspaces entry.
   */
    userValidation(fieldName: string, event: any): void {
      if (event.target.value) {
        const value = event.target.value;
        if (value[0] === ' ') {
          this.patientForm.get(fieldName).setValue(value.trimStart());
        }
      }
    }
  /**
   * Fetches the registered programs associated with the pharma ID.
   */
  fetchPharmaRegisteredProgram(): void {
    const pharmaId = localStorage.getItem('pharmaId');
    if (!pharmaId) { return; }

    this.store.dispatch(HomeAction.getPharmProgramList({
      keyword: '',
      limit: '200',
      pharma: pharmaId
    }));

    this.store.select(HomeSelector.getPharmaProgramList).subscribe(data => {
      if (!data) { return; }

      this.registeredProgramList = data.list?.map(obj => ({
        id: obj.Program?.Id,
        name: obj.Program.Name,
        code: obj.Program?.Code
      })) || [];
      this.filterRegisteredProgramList = this.registeredProgramList;

      const registeredProgramName = this.patientForm.get('registeredProgramName').value;
      if (registeredProgramName) {
        const filterOption = this.filterRegisteredProgramList.find(option => option.name === registeredProgramName);
        this.selectedPharmaProgram = filterOption;
      }
    });
  }

  /**
   * Filter the program list on input.
   */
  filterRegisteredProgram(event): void {
    this.filterRegisteredProgramList = this.registeredProgramList;
    const filtered: any[] = [];
    const query = event.query;

    for (const programList of this.registeredProgramList) {
      const program = programList;
      if (program.name.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(program);
      }
    }
    this.filterRegisteredProgramList = filtered;
  }
  /**
   * filter the gender list on input
   * @param event query data
   */

  filterGenderListData(event: any): void {
    this.filteredGenderList = this.genderList;
    const filtered: any[] = [];
    const query = event.query;

    for (const genderListItem of this.filteredGenderList) {
      const gender = genderListItem;
      if (gender.name.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(gender);
      }
    }
    this.filteredGenderList = filtered;
  }

  /**
   * get gender data
   */
  onInputData(event: any): void {
    const inputValue = event.target.value;
    const selectedOption = this.genderList.find(option => option.name.toLowerCase() === inputValue.toLowerCase());
    if (!selectedOption) {
      this.patientForm.get('patientGender')?.setValue('NA');
    }
  }

  /**
   * to set the selected country
   * from local storage
   */
  private setSelectedCountry(): void {
    const currentCountry = localStorage.getItem('country');
    if (currentCountry === COUNTRIES_LIST.THAILAND.value) {
      this.form.country.setValue('Thailand');
    }
  }

  /**
   * Check for a particular process
   */
  checkForProcess(): boolean {
    return this.process === TH_SPR_PROCESS;
  }

  checkForNovartis(): boolean {
    return this.process === NOVARTIS_PROCESS;
  }

  /**
   * check if the input field name exists for
   * given process
   * @param fieldName field name
   */
  checkIfFieldExists(fieldName: string): boolean {
    // TODO: remove the process check after full implementation
    if (this.process === OAZIS_FLOW_PROCESS || this.process === SG_BMS_NR_PND_1 || this.process === MY_NOVO_FLOW) {
      return fieldName in aeReportValidation[this.process]?.patientDetailsForm;
    }
    return true;
  }

  /**
   * check if the input field is mandatory or not
   */
  checkIfFieldIsMandatory(fieldName: string): boolean {
    // TODO: remove the process check after full implementation
    if (this.process === OAZIS_FLOW_PROCESS || this.process === SG_BMS_NR_PND_1 || this.process === MY_NOVO_FLOW) {
      return aeReportValidation[this.process]?.patientDetailsForm[fieldName]?.mandatory;
    }
    return true;
  }

  /**
   * get name of the field
   * @param fieldName field name
   * @returns name of field
   */
  getFieldName(fieldName: string): string {
    return aeReportValidation[this.process]?.patientDetailsForm[fieldName]?.title;
  }
  /**
   * get placeholder of the field
   * @param fieldName field name
   * @returns placeholder value of field
   */
  getFieldPlaceholder(fieldName: string): string {
    return aeReportValidation[this.process]?.patientDetailsForm[fieldName]?.placeholder;
  }

  /**
   * Unsubscribe the subscriptions.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.patientForm.reset();
  }
  /**
   * Check if process is for servier chatbot flow
   */
  checkForServierProcess(): boolean {
    return (this.process === TH_SERVIER_PROCESS || this.process === TH_SERVIER_PRIVATE_PROCESS || this.process === TH_SERVIER_PUBLIC_PROCESS);
  }
  /**
   * Check if process is for oazis
   */
  checkForOazisProcess(): boolean {
    return (this.process === OAZIS_FLOW_PROCESS || this.process === MY_NOVO_FLOW);
  }

  checkForSingaporeCountry(): boolean {
    return localStorage.getItem('country') === COUNTRIES_LIST.SINGAPORE.value || localStorage.getItem('country') === COUNTRIES_LIST.MALAYSIA.value;
  }

  /**
   * to get title of the form
   */
  getFormTitle(): string {
    return aeReportValidation[this.process]?.patientDetailsForm?.formTitle;
  }


  public onSelectProgram(event: any): void {
    this.selectedProgramDetails.emit(event);
  }

  public checkForDaichiiProcess(): boolean {
    return this.process === TH_DAICHII_PROCESS;
  }

}
